// GPLv3, Copyright (C) 2017, theBlock, https://theblock.io
// @flow

const APIKEY: string = '9243522442164813a467464a9dd2b25c'; // 'cDOZY87fOL0IECf1NZcO';

export {
  APIKEY
};



// WEBPACK FOOTER //
// ./packages/lib-services/src/infura.js